import { OnlyViewHoc } from 'hocs'
import { useState } from 'react'
import { store } from 'store'

import { logisticApi } from 'redux/services/logistic'
import { LogisticShortObject } from 'redux/services/logistic/types'

import { AppButton } from 'components/AppButton'
import { AppModalHeader } from 'components/AppModal/AppModalHeader'

import { LOGISTIC_STATUS_TEXT } from 'constants/logistic'

import { LabledInfo } from 'shared/ui'

import { EditLogisticModal } from '../Edit'
import styles from './Details.module.scss'

interface DetailsProps {
  data: LogisticShortObject
  onClose: () => void
}

export const Details = ({ data, onClose }: DetailsProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const [getLogisticCartForEdit, { data: logisticCartForEdit, isFetching }] =
    logisticApi.useLazyGetLogisticCartForEditQuery()
  //   const [
  //   getLogisticCartForEdit,
  //   { data: logisticCartForEdit, isFetching, error },
  // ] = logisticApi.useLazyGetLogisticCartForEditQuery()

  // useEffect(() => {
  //   if (error !== undefined) {
  //     // @ts-ignore
  //     const errorData = error?.data
  //     store.dialogStore.openErrorModal({
  //       title: 'Произошла ошибка',
  //       text: errorData?.message || 'Неизвестная ошибка',
  //     })
  //   }
  // }, [error])

  const handleClickAnketa = async () => {
    try {
      const applicationForEdit = await getLogisticCartForEdit({
        id: data.id,
      }).unwrap()
      if (applicationForEdit.anketa_file) {
        window.open(
          applicationForEdit.anketa_file,
          '_blank',
          'noopener,noreferrer',
        )
      } else {
        throw new Error('anketa file does not exist')
      }
    } catch (error: any) {
      store.dialogStore.openErrorModal({
        title: 'Произошла ошибка',
        text: error?.data?.message || 'Не удалось загрузить анкету',
      })
    }
    // try {
    //   if (!logisticCartForEdit) {
    //     const { data: cart } = await getLogisticCartForEdit({ id: data.id })
    //     window.open(
    //       cart?.anketa_file as string,
    //       '_blank',
    //       'noopener,noreferrer',
    //     )
    //   } else {
    //     window.open(
    //       logisticCartForEdit?.anketa_file as string,
    //       '_blank',
    //       'noopener,noreferrer',
    //     )
    //   }
    // } catch {}
  }

  const handleClickEdit = async () => {
    setIsOpen(true)
    // try {
    //   if (!data.anketa_file) {
    //     await getLogisticCartForEdit({ id: data.id })
    //   }
    // } finally {
    //   setIsOpen(true)
    // }
  }

  if (!data) {
    return null
  }

  return (
    <>
      <AppModalHeader onClose={onClose} title={`№${data.id}`} />
      <div className={styles.container}>
        <LabledInfo label="ФИО клиента">{data.client_full_name}</LabledInfo>
        <LabledInfo label="Адрес доставки">{data.address}</LabledInfo>
        <LabledInfo label="Тип">{data.card_type}</LabledInfo>
        <LabledInfo label="Номер">{data.phone}</LabledInfo>
        <LabledInfo label="ID">{data.barcode}</LabledInfo>
        <LabledInfo label="Дата заказа">{data.emboss_date}</LabledInfo>
        <LabledInfo label="Статус">
          {data.status ? LOGISTIC_STATUS_TEXT[data.status] : '-'}
        </LabledInfo>

        {/* {data.anketa_file && ( */}
        <AppButton
          variant="gray"
          size="small"
          onClick={handleClickAnketa}
          disabled={isFetching}
        >
          Анкета
        </AppButton>
        {/* )} */}

        <OnlyViewHoc>
          <AppButton
            onClick={handleClickEdit}
            size="small"
            disabled={!logisticCartForEdit}
            // disabled={
            //   isFetching || Boolean(data.anketa_file && !logisticCartForEdit)
            // }
          >
            Редактировать
          </AppButton>
          {/* {logisticCartForEdit && ( */}
          <EditLogisticModal
            // data={logisticCartForEdit}
            data={data}
            isOpen={isOpen}
            onClose={() => setIsOpen(false)}
          />
          {/* )} */}
        </OnlyViewHoc>
      </div>
    </>
  )
}
